import React from 'react';
import { PawPrint, FileText, MessageCircle, Camera, Check, ShieldCheck } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { images } from '../../data/content';
import { siteConfig } from '../../data/siteConfig';
const chips = [{
  icon: FileText,
  label: 'Documentos PDF + Word'
}, {
  icon: MessageCircle,
  label: '50 mensajes'
}, {
  icon: Camera,
  label: '30 posts'
}];
export function HeroSection() {
  return <>
      <div className="bg-forest-dark px-4 py-2.5 text-center font-display text-[12.5px] sm:text-[13.5px] font-semibold tracking-wide text-tangerine-light" data-id="element-76" data-mp="1sazaanapxh3n">
        <PawPrint className="mr-1.5 inline h-4 w-4 -translate-y-px" aria-hidden="true" data-id="element-77" data-mp="1ij3c7c8mtqzf" />
        <b className="text-white" data-id="element-78" data-mp="1dla7knmz9519">Precio de lanzamiento</b> · Descarga inmediata · Garantía de{' '}
        {siteConfig.guaranteeDays} días
      </div>
      <header id="hero" className="bg-forest pb-14 pt-9 text-cream md:pb-[70px] md:pt-14" data-id="element-79" data-mp="19idice2xmaoc">
        <div className="mx-auto grid max-w-[1120px] items-center gap-10 px-5 md:grid-cols-[1.05fr_.95fr]" data-id="element-80" data-mp="14klr7ma42sl7">
          <div className="text-center md:text-left" data-id="element-81" data-mp="31mtchk65fqbh">
            <div className="mb-5 flex items-center justify-center gap-2.5 font-display text-[15px] font-extrabold tracking-[0.16em] text-tangerine-light md:justify-start" data-id="element-82" data-mp="36fdyhzitcz4g">
              <PawPrint className="h-[22px] w-[22px]" fill="currentColor" aria-hidden="true" data-id="element-83" data-mp="2wp183qobibqe" />
              PASEO PRO
            </div>
            <h1 className="text-[34px] font-extrabold leading-[1.04] md:text-[52px]" data-id="element-84" data-mp="3kfou1fv2j1vy">
              Deja de improvisar. Convierte tus paseos en un{' '}
              <em className="not-italic text-tangerine-light" data-id="element-85" data-mp="3pbchnqtwjmzc">negocio profesional</em> desde hoy.
            </h1>
            <p className="mx-auto mt-[18px] max-w-[560px] text-[16.5px] leading-relaxed text-[#D7E6DC] md:mx-0 md:text-[18.5px]" data-id="element-86" data-mp="3gd0mrcm06313">
              Contrato, ficha del perro, autorización veterinaria, lista de precios, 50 mensajes de
              WhatsApp y 30 posts listos para publicar. Todo lo que necesitas para verte
              profesional, cobrar mejor y trabajar tranquilo/a, sin crear nada desde cero.
            </p>
            <ul className="my-7 flex flex-wrap justify-center gap-2.5 md:justify-start" data-id="element-87" data-mp="5iacy76jrg36">
              {chips.map(({
              icon: Icon,
              label
            }) => <li key={label} className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/[0.08] px-[15px] py-2 text-sm font-semibold" data-id="element-88" data-mp="pqzda7v0kyd">
                  <Icon className="h-4 w-4 text-tangerine-light" aria-hidden="true" data-id="element-89" data-mp="3ixgdkz0d7kj4" />
                  {label}
                </li>)}
            </ul>
            <CtaButton size="lg" sublabel={`Pago único de ${siteConfig.price}`} data-id="element-90" data-mp="3dyvmpq706d7c">
              Quiero mi kit ahora
            </CtaButton>
            <div className="mt-3.5 flex flex-wrap justify-center gap-x-4 gap-y-1.5 text-[13.5px] text-forest-soft md:justify-start" data-id="element-91" data-mp="1c70e5jg1motc">
              <span className="inline-flex items-center gap-1.5" data-id="element-92" data-mp="186gjqnmutzaw">
                <Check className="h-4 w-4 text-tangerine-light" aria-hidden="true" data-id="element-93" data-mp="2q3a6fsibzzs5" />
                Acceso inmediato por email
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-94" data-mp="2v0tt9gt3hkvp">
                <ShieldCheck className="h-4 w-4 text-tangerine-light" aria-hidden="true" data-id="element-95" data-mp="2zsbnlm0m4n7p" />
                Garantía {siteConfig.guaranteeDays} días
              </span>
            </div>
          </div>
          <div className="mx-auto w-full max-w-[340px] sm:max-w-[420px] md:max-w-[480px]" data-id="element-96" data-mp="274plki719qmy">
            <img src={images.heroKit} alt="Kit PASEO PRO: libro, contrato de servicios, perfil de mascota, mensajes de WhatsApp y posts para Instagram" className="mx-auto block h-auto w-full max-w-[480px] rounded-[28px] shadow-[0_30px_60px_-20px_rgba(0,0,0,.5)]" width={1122} height={1402} data-id="element-97" data-mp="2c2r0cqxff3sm" />
          </div>
        </div>
      </header>
    </>;
}